import { IFormService } from "../../service/form/FormService";

export default class AddRowInteractor {
  private formService: IFormService;

  constructor(formService) {
    this.formService = formService;
  }

  async execute(formId: number, formSectionId: number) {
    await this.formService.addRow(formId, formSectionId);
  }
}
